// ══════════════════════════════════════════════════════════════════════
//  KASI TATU ZA IFR — Classical, Rapid, Blitz
//  Kama FIDE: kila kasi ina rating yake, historia yake, na K-factor
//  yake — HAZICHANGANYIKI KAMWE. Mchezo wa Blitz kamwe hauguswi rating
//  ya Classical, na kinyume chake.
//
//  MUUNDO WA DATA: badala ya kuweka kila kitu ndani ya "ratings: {...}"
//  (jambo ambalo lingehitaji kuhamisha data ya Classical iliyopo tayari),
//  Classical inaendelea kutumia majina yaleyale ya field ambayo IFR
//  ilianza nayo (ifr, established, gamesRated, ...) — SIFURI HATARI kwa
//  wachezaji waliokwisha kusajiliwa. Rapid na Blitz zinaongeza field
//  mpya zenye "Rapid"/"Blitz" mwishoni (ifrRapid, establishedRapid, ...).
// ══════════════════════════════════════════════════════════════════════

export const RATING_CATEGORIES = [
  {
    key: 'classical', label: 'Classical', shortLabel: 'STD', suffix: '',
    description: 'Dakika 60+ kwa kila mtu. Hii ndiyo yenye Titles na norms.',
    color: '#14452F',
  },
  {
    key: 'rapid', label: 'Rapid', shortLabel: 'RAP', suffix: 'Rapid',
    description: 'Zaidi ya dakika 10, chini ya dakika 60.',
    color: '#B45309',
  },
  {
    key: 'blitz', label: 'Blitz', shortLabel: 'BLZ', suffix: 'Blitz',
    description: 'Dakika 10 au chini.',
    color: '#7C3AED',
  },
];

export function categoryInfo(key) {
  return RATING_CATEGORIES.find(c => c.key === key) || RATING_CATEGORIES[0];
}

// Majina ya field za mchezaji kwa kasi husika. Classical -> majina ya
// asili (bila suffix); Rapid/Blitz -> majina yenye suffix.
export function fieldsFor(categoryKey) {
  const s = categoryInfo(categoryKey).suffix;
  return {
    ifr: `ifr${s}`,
    established: `established${s}`,
    gamesRated: `gamesRated${s}`,
    unratedGames: `unratedGames${s}`,
    history: `history${s}`,
    lastActivePeriod: `lastActivePeriod${s}`,
  };
}

// Soma rating ya mchezaji kwa kasi husika, ikiwa haijawekwa bado rudisha null
export function ratingOf(player, categoryKey) {
  if (!player) return null;
  const f = fieldsFor(categoryKey);
  return player[f.established] && typeof player[f.ifr] === 'number' ? player[f.ifr] : null;
}
